import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function DashboardPlaceholder() {
  const { account } = useAuth();
  const location = useLocation();
  const successMessage = location.state?.onboardingSuccess
    ? `Agente "${location.state.agentName}" criado com sucesso!`
    : null;

  return (
    <div className="max-w-2xl mx-auto px-4 py-12 text-center">
      <h1 className="text-2xl font-bold text-content-primary mb-2">Painel</h1>
      {account && (
        <p className="text-content-secondary mb-2">
          {account.name} · {account.email}
        </p>
      )}
      {successMessage && (
        <p className="text-forge-600 text-sm mb-4">{successMessage}</p>
      )}
      <p className="text-content-muted mb-8">
        Gerencie agentes, sub-agentes e knowledge bases.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/agents" className="btn-primary">
          Ver agentes
        </Link>
        <Link to="/onboarding" className="btn-secondary">
          Criar agente
        </Link>
        <Link to="/" className="btn-secondary">
          Voltar para início
        </Link>
      </div>
    </div>
  );
}

export default DashboardPlaceholder;
